export class MockeyEventPlugin {}
